import { updateDiagramHighlight, getDiagramHighlight, rebuildPVDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type HighlightProps = {
    highlightLoops?: boolean;
    stepColourVolume?: boolean;
    stepColourDuration?: boolean;
    stepColourStdDeviation?: boolean;
}

export const changeHighlight = ({
    highlightLoops,
    stepColourVolume,
    stepColourDuration,
    stepColourStdDeviation,
}: HighlightProps) => {
    updateDiagramHighlight({ highlightLoops, stepColourVolume, stepColourDuration, stepColourStdDeviation});
    rebuildPVDiagram('updateDiagramHighlight');
};

export const getHighlight = (): HighlightProps => getDiagramHighlight();
